export default "__VITE_ASSET__b83f3592__"